import { ReactNode } from 'react';
import {
  MenuBook as BookText,
  Business as Building2,
  Event as Calendar,
  AccountTree as GitMerge,
  Place as MapPin,
  People as Users,
} from '@mui/icons-material';

export interface DashboardCounts {
  chapters: number;
  characters: number;
  locations: number;
  organizations: number;
  events: number;
}

export interface DashboardItem {
  id: string;
  title: string;
  count: number | string;
  icon: ReactNode;
  href: string;
  description: string;
}

export function getDashboardItems(
  t: (key: string) => string,
  counts: DashboardCounts,
  viewText: string
): DashboardItem[] {
  return [
    {
      id: 'chapters',
      title: t('dashboard.home.items.chapters.title'),
      count: counts.chapters,
      icon: <BookText sx={{ fontSize: 24, color: '#a1824a' }} />,
      href: '/scenes',
      description: t('dashboard.home.items.chapters.description'),
    },
    {
      id: 'characters',
      title: t('dashboard.home.items.characters.title'),
      count: counts.characters,
      icon: <Users sx={{ fontSize: 24, color: '#a1824a' }} />,
      href: '/characters',
      description: t('dashboard.home.items.characters.description'),
    },
    {
      id: 'locations',
      title: t('dashboard.home.items.locations.title'),
      count: counts.locations,
      icon: <MapPin sx={{ fontSize: 24, color: '#a1824a' }} />,
      href: '/locations',
      description: t('dashboard.home.items.locations.description'),
    },
    {
      id: 'organizations',
      title: t('dashboard.home.items.organizations.title'),
      count: counts.organizations,
      icon: <Building2 sx={{ fontSize: 24, color: '#a1824a' }} />,
      href: '/organizations',
      description: t('dashboard.home.items.organizations.description'),
    },
    {
      id: 'events',
      title: t('dashboard.home.items.events.title'),
      count: counts.events,
      icon: <Calendar sx={{ fontSize: 24, color: '#a1824a' }} />,
      href: '/events',
      description: t('dashboard.home.items.events.description'),
    },
    {
      id: 'relationships',
      title: t('dashboard.home.items.relationships.title'),
      count: viewText,
      icon: <GitMerge sx={{ fontSize: 24, color: '#a1824a' }} />,
      href: '/relationships',
      description: t('dashboard.home.items.relationships.description'),
    },
  ];
}
